<div id="bubble" #bubble class="h-100 w-100">
    <p *ngIf="!bubbleData.length" class="mt">No Data</p>
</div>